import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createGlobalStyle, StyleSheetManager, ThemeProvider } from 'styled-components';
import ReactNotifications from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { BrowserRouter } from 'react-router-dom';

import { isCp, applyDesignAssets } from 'libs/design';
import { GlobalDesignStyle as GlobalClassic } from './index.classic.styles';
import { GlobalDesignStyle as GlobalCp } from './index.cp.styles';
import './i18n';
import { App } from './app/app';
import store from './store/store';

import './config';

applyDesignAssets();

const GlobalStyle = config.theme?.body?.background
  ? createGlobalStyle`
  body {
    background: ${config.theme.body.background};
  }
`
  : null;

const filterProps = (prop) => {
  return !['absoluteErrors', 'active', 'show', 'mergedLeftInput', 'mergedRightInput', 'fullWidth', 'error', 'loading', 'single'].includes(prop);
};

const theme = 'dark';
// ui: 'v2' — новый дизайн (CP), 'v1' — классический; используется в styled-components: props.theme.ui === 'v2'
const ui = isCp ? 'v2' : 'v1';

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <StyleSheetManager shouldForwardProp={filterProps}>
        <ThemeProvider theme={{ theme, ui }}>
          {isCp ? <GlobalCp /> : <GlobalClassic />}
          {GlobalStyle && <GlobalStyle />}
          <ReactNotifications />
          <App />
        </ThemeProvider>
      </StyleSheetManager>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);
